import { StringParam, withDefault } from 'use-query-params';
import { SchemaFilterType, SortDir } from '@ui/src';

export const blacklistListColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'name',
    label: 'List name',
  },
  {
    name: 'active',
    label: 'Status',
    sortable: true,
  },
  {
    name: 'source',
    label: 'Source',
    sortable: false,
  },
  {
    name: 'createdAt',
    label: 'Date created',
    sortable: true,
  },
  {
    name: 'updatedAt',
    label: 'Date updated',
    sortable: true,
  },
  {
    name: 'lastTrySyncDate',
    label: 'Attempt update date',
    sortable: true,
  },
  {
    name: 'successfulSyncLastDate',
    label: 'Last sync',
    sortable: true,
  },
];

export const blacklistListDefaultSorter = {
  sortProp: blacklistListColumns[2].name,
  sortDir: SortDir.DESC,
};

export const blacklistListSchema = {
  sortProp: {
    value: withDefault(StringParam, blacklistListDefaultSorter.sortProp),
    type: SchemaFilterType.STRING,
  },
  sortDir: {
    value: withDefault(StringParam, blacklistListDefaultSorter.sortDir),
    type: SchemaFilterType.STRING,
  },
};
